import toast from "@/services/Notification";
import HTTP from "@/_helpers/http";
import { TICKETS__MUTATIONS } from "../mutation-types";
import { TICKETS__ACTIONS } from "../action-types";
import { TICKETS__API } from "@/_helpers/urls";

// State
const state = {
  messages: [],
};

//Getters
const getters = {};

//Mutations
const mutations = {
 [TICKETS__MUTATIONS.MESSAGES](state, data) {
  state.messages = data.map(m => ({
    ...m,
    is_seen: m.is_seen === 1 || m.is_seen === true 
  }));
},

[TICKETS__MUTATIONS.MARKSEEN](state, updatedTicket) {
  const index = state.messages.findIndex(m => m.id == updatedTicket.id);
  if (index !== -1) {
    state.messages[index].is_seen = updatedTicket.is_seen === 1 || updatedTicket.is_seen === true;
  }
},


};
// Actions
const actions = {
  async [TICKETS__ACTIONS.MARKSEEN]({ commit }, payload) {
  try {
    const response = await HTTP().post(TICKETS__API.MARKSEEN, payload);
    commit(TICKETS__MUTATIONS.MARKSEEN, response.data.ticket);
  } catch (error) {
    console.error("Seen Update Error:", error);
  }
},

  async [TICKETS__ACTIONS.MESSAGES]({ commit }, parameter) {
    try {
      const response = await HTTP().post(TICKETS__API.MESSAGES, parameter);
      commit(TICKETS__MUTATIONS.MESSAGES, response?.data?.messages);

      return {
        meta: response.data.meta,
      };
    } catch (error) {
      console.error(error);
    }
  },

  // async [TICKETS__ACTIONS.REPLY]({ dispatch }, parameter) {
  //   try {
  //     const adminIdParam =
  //       parameter?.admin_id != null ? `admin_id=${parameter.admin_id}` : "";

  //     const commentParam =
  //       parameter?.comment != null
  //         ? `comment=${encodeURIComponent(parameter.comment)}`
  //         : "";

  //     const client_ticket_idParam =
  //       parameter?.client_ticket_id != null
  //         ? `client_ticket_id=${parameter.client_ticket_id}`
  //         : "";

  //     const client_idParam =
  //       parameter?.client_id != null ? `client_id=${parameter.client_id}` : "";

  //     const parameterString = [
  //       adminIdParam,
  //       commentParam,
  //       client_ticket_idParam,
  //       client_idParam,
  //     ]
  //       .filter((param) => param !== "")
  //       .join("&");

  //     await HTTP().post(
  //       TICKETS__API.REPLY +
  //         (parameterString !== "" ? `?${parameterString}` : "")
  //     );
  //     //await dispatch(TICKETS__ACTIONS.MESSAGES);
  //   } catch (error) {
  //     console.error(error);
  //     toast.error(error.response.data.message);
  //   }
  // },


  async [TICKETS__ACTIONS.REPLY]({ dispatch }, parameter) {
  try {
    const formData = new FormData();

    if (parameter.comment) formData.append("comment", parameter.comment);
    if (parameter.client_ticket_id) formData.append("client_ticket_id", parameter.client_ticket_id);
    if (parameter.client_id) formData.append("client_id", parameter.client_id);
    if (parameter.admin_id) formData.append("admin_id", parameter.admin_id);

    // append image if exists
    if (parameter.image) formData.append("image", parameter.image);

    await HTTP().post(TICKETS__API.REPLY, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    // reload tickets after reply
    await dispatch(TICKETS__ACTIONS.MESSAGES);

    toast.success("Reply sent successfully!");
  } catch (error) {
    console.error(error);
    toast.error(error.response?.data?.message || "Failed to send reply");
  }
},

  async [TICKETS__ACTIONS.TOGGLE_TICKET]({ dispatch }, parameter) {
    try {
      await HTTP().post(TICKETS__API.TOGGLE_TICKET, parameter);
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message);
    }
  },

  async [TICKETS__ACTIONS.DELETECOMMENT]({ dispatch }, parameter) {
    try {
      const response = await HTTP().post(
        `${TICKETS__API.DELETECOMMENT}/${parameter.id}`
      );

      if (response.status === 200) {
        toast.success(response.data.message);
      }
    } catch (error) {
      toast.error("Delete failed");
      console.error("Delete error:", error.response?.data || error.message);
    }
  },

  async [TICKETS__ACTIONS.UPDATECOMMENT]({ dispatch }, parameter) {
    try {
      const response = await HTTP().patch(
        `${TICKETS__API.UPDATECOMMENT}/${parameter.id}`,
        parameter
      );
      if (response.status === 200) {
        toast.success("Ticket replay has been edited.");
      }
    } catch (error) {
      console.error("Error updating server config:", error);
      toast.error(error.response?.data?.message || "Update failed");
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
